export enum OrderTypeEnum {
    Unknown = 'Unknown',
    SalesOrder = 'SalesOrder',
    RentalOrder = 'RentalOrder',
}
